var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":`mailto:${_vm.supportEmailAddress}`},domProps:{"textContent":_vm._s(_vm.supportEmailAddress)}})
}
var staticRenderFns = []

export { render, staticRenderFns }